//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {rsaEncryFn} from "@/utils/commons";

export default {
  name: "driver-register",
  data(){
    return{
      activationForm:{},
      passwordChangeBol:false
    }
  },
  methods:{
    register(){
      this.$refs['activationForm'].validate((valid) => {
        if(!valid){
          return;
        }
        this.$loadingShow();
        this.activationForm.firstLogin = true;
        this.$post('api/driver/register',this.activationForm).then((res) => {
          this.$vux.toast.text('注册成功');
          let loginObj = {
            username: this.activationForm.phone,
            password: this.activationForm.password
          };
          if (loginObj.password) {
            loginObj.password = rsaEncryFn(loginObj.password);
          }
          this.$post('api/login', loginObj).then((res) => {
            this.$loadingHide();
            localStorage.setItem('_token', "Bearer " + res.token);

            setTimeout(() => {
              this.getCurrent();
              if(this.$route.query.redirect){
                this.$router.push(this.$route.query.redirect);
              }else{
                this.$router.push('/driver/my-delivery');
              }
            });
          }).catch(() => {
            this.$loadingHide();
          })
        }).catch(() => {
          this.$loadingHide();
        })
      });
    },
    phoneValidFn(rule, value, callback){
      if (!(/^1[3456789]\d{9}$/.test(value))) {
        callback(new Error('手机号码格式不正确'));
      } else {
        callback();
      }
    },
    passwordFn(rule, value, callback){
      if(value.length < 5){
        callback(new Error('密码最少5个字符'));
      }else{
        callback();
      }
    },
    phoneChange(){
      if(this.activationForm.phone.length > 5 && !this.passwordChangeBol){
        let pas = this.activationForm.phone.substring(this.activationForm.phone.length-5);
        this.$set(this.activationForm,'password',pas);
      }
    },
    passwordChange(){
      this.passwordChangeBol = true;
    },
    //  获取当前用户信息
    getCurrent() {
      this.$get('api/person/current').then((data) => {
        this.$store.dispatch('commitChangeType', data.userType);
        this.$store.dispatch('commitChangeUserId', data.id);
        if (this.$store.state.userType == '1') {
          this.$store.dispatch('commitChangeSupId', null);
        } else {
          if(this.$route.meta && this.$route.meta.driver){
            return;
          }
          this.$get('api/supplier/current-sample').then((res) => {
            this.$store.dispatch('commitChangeSupId', res.id);
          })
        }
      });
    },
  },
  mounted(){
    if(this.$route.query.phone){
      this.$set(this.activationForm,'phone',this.$route.query.phone);
      if(this.activationForm.phone.length > 5){
        let pas = this.activationForm.phone.substring(this.activationForm.phone.length-5);
        this.$set(this.activationForm,'password',pas);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/driver/driver-register.vue